import React from 'react'
import {Table, Popup, Icon, Loader, Button} from 'semantic-ui-react'
import {Selection, Eventdetails} from './';

export function Events(props) {
    return (
        <div style={{
            position: 'fixed',
            left: 0,
            right: 0,
            bottom: 0,
            top: '42px',
            display: 'flex'
        }}>
            <div style={{
                width: '300px',
                backgroundColor: '#EEEEEE'
            }}><Selection /></div>
            <div style={{
                flexGrow: 1,
                display: 'flex'
            }}>
                <Eventdetails />
            </div>
        </div>
    )
}